<template>
    <!--
      Warm up Crane brand stacks before visible hero copy renders.
      Invisible glyphs expand @font-face requests so swaps happen earlier on slow networks.
    -->
    <div
        class="pointer-events-none fixed top-0 left-[-9999px] size-px overflow-hidden opacity-0"
        aria-hidden="true"
    >
        <!-- Playfair: heading + italic headline pattern -->
        <span class="font-serif text-[1px] leading-none font-normal">Note</span>
        <span class="font-serif text-[1px] leading-none font-normal italic">received.</span>

        <!-- Montserrat: eyebrow/light through bold + italic sans -->
        <span class="font-sans text-[1px] leading-none font-light">Aa</span>
        <span class="font-sans text-[1px] leading-none font-normal">Aa</span>
        <span class="font-sans text-[1px] leading-none font-medium">Aa</span>
        <span class="font-sans text-[1px] leading-none font-semibold">Aa</span>
        <span class="font-sans text-[1px] leading-none font-bold">Aa</span>
        <span class="font-sans text-[1px] leading-none font-normal italic">Aa</span>
    </div>
</template>
